import { render, staticRenderFns } from "./ChapterCategoryPage.vue?vue&type=template&id=5a2dc47e&scoped=true&lang=pug"
import script from "./ChapterCategoryPage.vue?vue&type=script&lang=js"
export * from "./ChapterCategoryPage.vue?vue&type=script&lang=js"
import style0 from "./ChapterCategoryPage.vue?vue&type=style&index=0&id=5a2dc47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2dc47e",
  null
  
)

export default component.exports